import { createMasterDataCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type ComplaintcategoryDto = EntityRecord;
export type ComplaintcategoryCreateRequest = EntityCreateRequest;
export type ComplaintcategoryUpdateRequest = EntityUpdateRequest;

export const complaintCategoryApi: CrudApi<ComplaintcategoryDto, ComplaintcategoryCreateRequest, ComplaintcategoryUpdateRequest> = createMasterDataCrudApi({ masterType: "complaint-category" });
